angular.module("dx.webapp.student").constant("ValidStudentCodeCharsRegExp", /^[a-zA-Z0-9_.@-]*$/);
